<template>
  <i class="fa fa-fw fa-mobile"></i>
</template>

<script>
export default {
  name: 'Mobile',
};
</script>

<style scoped>
.fa-mobile {
  color: #2993cf;
}
</style>




// WEBPACK FOOTER //
// MobileIcon.vue?cc515bb8